/**
 * Azure AD Authentication Configuration
 *
 * IMPORTANT: Before deploying, you must:
 * 1. Register an app in Azure AD (Azure Portal > Azure Active Directory > App registrations)
 * 2. Set redirect URIs in Azure AD app:
 *    - https://dev.transtarnetworks.eu
 *    - https://dev.transtarnetworks.eu/redirect
 *    - http://localhost:3000 (for local dev)
 * 3. Copy the Application (client) ID and Directory (tenant) ID
 * 4. Set these values in environment variables or replace below
 */

export const msalConfig = {
  auth: {
    clientId: '2883f0f4-e888-4399-9084-d97d4aeda41f',
    authority: 'https://login.microsoftonline.com/1e340a41-f9ff-4cf1-9cbb-53272ca6a383',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0:
            console.error('MSAL Error:', message);
            return;
          case 1:
            console.warn('MSAL Warning:', message);
            return;
          case 2:
            console.info('MSAL Info:', message);
            return;
          case 3:
            console.debug('MSAL Debug:', message);
            return;
          default:
            return;
        }
      },
      logLevel: 3,
    },
  },
};

/**
 * Scopes for ID token (user authentication)
 */
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

/**
 * Scopes for API access tokens
 */
export const tokenRequest = {
  scopes: ['User.Read'],
};

/**
 * Graph API endpoint for user profile
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
